// soundList entry ids. crypto.randomUUID is the platform UID source (no direct
// uuid/nanoid dep in package.json); the fallback covers non-secure/legacy contexts.
export function newSoundId() {
  const uid =
    typeof crypto !== "undefined" && typeof crypto.randomUUID === "function"
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
  return `sound-${uid}`;
}

// A copied scene (duplicate / template / paste) must not share sound ids with
// its source: later edits change `file` but keep the id, and the Visor keys
// Howls per id — shared ids made one scene's narration play in the others.
export function withFreshSoundIds(soundList) {
  if (!Array.isArray(soundList)) return soundList;
  return soundList.map((s) => (s ? { ...s, id: newSoundId() } : s));
}
